(function() {
  let lastProcessedUrl = "";

  function fetchAndUpdateProduct(handle) {
    const jsonUrl = `/products/${handle}.json`;

    fetch(jsonUrl)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        if (!data.product || !data.product.id) return;
        const newProductId = data.product.id;

        if (window.__st) {
          window.__st.rid = newProductId;
          window.__st.pageurl = window.location.href;
        }

        if (typeof videowiseBulkTrigger === 'function') {
          
          const shopifyBlocks = document.querySelectorAll('[class*="videowise_video_commerce"], [id*="reeview-app-widget"]');
          
          shopifyBlocks.forEach(block => {
           
            const clone = block.cloneNode(false); 
            
            if (clone.hasAttribute('data-product-id')) {
              clone.setAttribute('data-product-id', newProductId);
            }
            
            clone.innerHTML = '';
            
            block.parentNode.replaceChild(clone, block);
          });

          setTimeout(() => {
            
            window.videowiseIdsLoaded = [];
            
            if (typeof initVideowise === 'function') {
              try { initVideowise(); } catch(e){}
            }
            
            window.videowiseBulkTrigger();
          }, 400); 
        }
      })
      .catch(err => console.error('❌ Update error:', err));
  }

  const pushState = history.pushState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    handleUrlChange();
  };
  const replaceState = history.replaceState;
  history.replaceState = function() {
    replaceState.apply(history, arguments);
    handleUrlChange();
  };
  window.addEventListener("popstate", handleUrlChange);

  function handleUrlChange() {
    const currentUrl = window.location.pathname;
    if (currentUrl === lastProcessedUrl) return;
    lastProcessedUrl = currentUrl;

    const handle = currentUrl.split("/").pop();
    if (handle && currentUrl.includes('/products/')) {
      fetchAndUpdateProduct(handle);
    }
  }

  handleUrlChange();
})();